/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { StockFisikApi } from "api"
import Axios from "axios"
import { ActionButton, Alert, DataStatus } from "components"
import { Formik } from "formik"
import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { FormSection, TableSection } from "../Section"
import {
  formInitialValues,
  formSubmitMapper,
  formValidationSchema,
} from "../Utils"

const TambahStockFisik = ({ setNavbarTitle }) => {
  const history = useHistory();
  const location = useLocation();
  const [dataBahan, setDataBahan] = useState([]);
  const [dataUnitProduksi, setDataUnitProduksi] = useState([]);
  const [fetchingStatus, setFetchingStatus] = useState({
    loading: false,
    success: true,
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });

  const mappingDataUnitProduksi = (data) =>
    data.map((val) => ({
      value: val?.id_unit_produksi,
      label: val.nama_unit_produksi,
    }));

  const getInitialValues = () => {
    setFetchingStatus({ loading: true, success: false });

    Axios.all([StockFisikApi.getBahan(), StockFisikApi.dropdownUnitProduksi()])
      .then(
        Axios.spread((bahan, unit_produksi) => {
          const mapDataUnitProduksi = mappingDataUnitProduksi(
            unit_produksi.data.data
          );
          setDataBahan(bahan.data.data);
          setDataUnitProduksi(mapDataUnitProduksi);

          setFetchingStatus({
            loading: false,
            success: true,
          });
        })
      )
      .catch(() => {
        setAlertConfig({
          show: false,
          variant: "primary",
          text: "Data gagal dimuat!",
        });
        setFetchingStatus({
          loading: false,
          success: false,
        });
      });
  };

  const formSubmitHandler = (values) => {
    StockFisikApi.create(formSubmitMapper(values))
      .then(() => {
        history.push("/inventory/transaksi/stock-fisik", {
          alert: {
            show: true,
            variant: "primary",
            text: "Data berhasil disimpan!",
          },
          do: location?.state?.do,
        });
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal disimpan!",
        });
      })
      .finally(() => {});
  };

  useEffect(() => {
    setNavbarTitle("Stock Fisik");
    getInitialValues();
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues({}, [])}
      validationSchema={formValidationSchema}
      onSubmit={formSubmitHandler}>
      {(formik) => (
        <>
          <Alert
            show={alertConfig.show}
            variant={alertConfig.variant}
            text={alertConfig.text}
            showCloseButton={true}
            onClose={() =>
              setAlertConfig({
                ...alertConfig,
                show: false,
              })
            }
          />
          {fetchingStatus.loading ? (
            <DataStatus loading text="Memuat . . ." />
          ) : fetchingStatus.success ? (
            <form onSubmit={formik.handleSubmit}>
              <FormSection dataUnitProduksi={dataUnitProduksi} />
              <TableSection />
              <div className="d-flex justify-content-end">
                <ActionButton
                  type="submit"
                  text="Simpan"
                  loading={formik.isSubmitting}
                />
              </div>
            </form>
          ) : (
            <DataStatus text="Data gagal dimuat" />
          )}
        </>
      )}
    </Formik>
  );
};

export default TambahStockFisik;
